import type { StoreApi } from "zustand";
import type { TChatStore } from "../chat-store.types";
import type { TMessageUnread } from "./message.types";
import { messageUnreadInitialState } from "./message.initial-state";

type TSetState = StoreApi<TChatStore>["setState"];

export const createMessageUnreadActions = (set: TSetState) => ({
  setMessageUnreadFulfilled: (source: TMessageUnread) =>
    set(() => ({
      messageUnread: { ...messageUnreadInitialState, fetched: true, source },
    })),

  resetMessageUnread: () =>
    set(() => ({ messageUnread: messageUnreadInitialState })),
});
